exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-switch{padding:0 15px 15px}.page-switch-sample{margin:0 15px}.page-switch-text{margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-450f60ed!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-markdown-loader/_cache/switch-3.vue
// module id = 216
// module chunks = 0